import { Routes } from '@angular/router';
import { Layout } from './layout/layout';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';
import { aclGuard } from './guards/acl.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./auth/login/login').then((m) => m.Login)
  },
  {
    path: 'verify-otp',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./auth/verify-otp/verify-otp').then((m) => m.VerifyOtp)
  },
  {
    path: 'forgot-password',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./auth/forgot-password/forgot-password').then((m) => m.ForgotPassword)
  },
  {
    path: 'reset-password/:email/:token',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./auth/reset-password/reset-password').then((m) => m.ResetPassword)
  },
  {
    path: '404',
    loadComponent: () =>
      import('./auth/not-found-page/not-found-page').then((m) => m.NotFoundPage)
  },
  {
    path: '',
    component: Layout,
    canActivate: [authGuard],
    children: [
      {
        path: 'clinics',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-clinics/manage-clinics').then((m) => m.ManageClinics)
      },
      {
        path: 'clinics/add',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-clinics/add-clinic/add-clinic')
            .then(m => m.AddClinic)
      },
       {
        path: 'clinics/edit/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-clinics/add-clinic/add-clinic')
            .then(m => m.AddClinic)
      },
      {
        path: 'clinics/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-clinics/clinic-details/clinic-details')
            .then(m => m.ClinicDetails)
      },
      {
        path: 'codes',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-codes/manage-codes').then((m) => m.ManageCodes)
      },
      {
        path: 'claims',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-claims/manage-claims').then((m) => m.ManageClaims)
      },
      {
        path: 'patients',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-patients/manage-patients').then((m) => m.ManagePatients)
      },
      {
        path: 'patients/add',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-patients/add-patient/add-patient')
            .then(m => m.AddPatient)
      },
      {
        path: 'patients/edit/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-patients/add-patient/add-patient')
            .then(m => m.AddPatient)
      },
      {
        path: 'patients/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-patients/patient-details/patient-details')
            .then(m => m.PatientDetails)
      },
      {
        path: 'claim-form-rules',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/global-claim-form-rule/global-claim-form-rule').then((m) => m.GlobalClaimFormRule)
      },
      {
        path: 'payer-rules',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/payer-and-claim-type-rules/payer-and-claim-type-rules').then((m) => m.PayerAndClaimTypeRules)
      },
      {
        path: 'payer-rules/add',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/payer-and-claim-type-rules/add-payer/add-payer')
            .then(m => m.AddPayer)
      },
      {
        path: 'payer-rules/edit/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/payer-and-claim-type-rules/add-payer/add-payer')
            .then(m => m.AddPayer)
      },
      {
        path: 'payer-rules/view/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/payer-and-claim-type-rules/add-payer/add-payer')
            .then(m => m.AddPayer)
      },
      {
        path: 'staff-users',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-staff-users/manage-staff-users').then((m) => m.ManageStaffUsers)
      },
      {
        path: 'staff-users/add',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-staff-users/add-staff-user/add-staff-user').then((m) => m.AddStaffUser)
      },
       {
        path: 'staff-users/edit/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-staff-users/add-staff-user/add-staff-user').then((m) => m.AddStaffUser)
      },
      {
        path: 'providers',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-providers/manage-providers').then((m) => m.ManageProviders)
      },
      {
        path: 'providers/add',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-providers/add-provider/add-provider').then((m) => m.AddProvider)
      },
      {
        path: 'providers/edit/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-providers/add-provider/add-provider').then((m) => m.AddProvider)
      },
      {
        path: 'providers/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/manage-providers/provider-details/provider-details')
            .then(m => m.ProviderDetails)
      },
      {
        path: 'documents',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/documents-configuration/documents-configuration').then((m) => m.DocumentsConfiguration)
      },
      {
        path: 'claim-form-templates',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/claim-form-templates/claim-form-templates').then((m) => m.ClaimFormTemplates)
      },
      {
        path: 'claim-form-templates/add',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/claim-form-templates/add-claim-form-template/add-claim-form-template')
            .then(m => m.AddClaimFormTemplate)
      },
      {
        path: 'claim-form-templates/edit/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/claim-form-templates/add-claim-form-template/add-claim-form-template')
            .then(m => m.AddClaimFormTemplate)
      },
      {
        path: 'claim-form-templates/view/:id',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/claim-form-templates/add-claim-form-template/add-claim-form-template')
            .then(m => m.AddClaimFormTemplate)
      },
      {
        path: 'ocr-settings',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/ocr-ai-settings/ocr-ai-settings').then((m) => m.OcrAiSettings)
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile')
            .then(m => m.Profile)
      },
      {
        path: 'audit-logs',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/audit-logs/audit-logs')
            .then(m => m.ManageAudits)
      },
      {
        path: 'reports/token-reports',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/reports/token-reports/token-reports').then((m) => m.TokenReports)
      },
      {
        path: 'reports/split-claims',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/reports/split-claim-reports/split-claim-reports').then((m) => m.SplitClaimReports)
      },
      {
        path: 'reports/claims',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/reports/claim-reports/claim-reports').then((m) => m.ClaimReports)
      },
      {
        path: 'reports/financial',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/reports/financial-reports/financial-reports').then((m) => m.FinancialReports)
      },
      {
        path: 'reports/financial/details',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/reports/financial-reports/financial-report-details/financial-report-details').then((m) => m.FinancialReportDetails)
      },
      {
        path: 'reports/claims/details',
        canActivate: [aclGuard],
        loadComponent: () =>
          import('./features/reports/claim-reports/claim-report-details/claim-report-details').then((m) => m.ClaimReportDetails)
      },

      {
        path: '',
        redirectTo: '/profile',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];